import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../common/errors/useApiError";
import { useSaveMe } from "./useMeEditor";

interface FormValues {
  lastName: string;
}

export const ChangeLastName: React.FC = () => {
  const { saveMe, isSaving } = useSaveMe();
  const { t } = useTranslation();
  const { me } = useLoggedInWithOrgContextState();
  const toast = useToast();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      lastName: me.lastName ?? undefined,
    },
  });

  const value = watch("lastName");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveMe({
        lastName: values.lastName,
      });
      toast({ title: t("Last name has been updated!"), status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt="15px" isInvalid={errors.lastName !== undefined}>
          <FormLabel htmlFor={"lastName"}>{t("Last name")}</FormLabel>
          <Input
            id={"lastName"}
            type="text"
            {...register("lastName", {
              required: t("Please provide your last name") ?? "",
              minLength: {
                value: 2,
                message: t("Must be at least 2 characters long"),
              },
            })}
          />
          <FormErrorMessage>{errors.lastName && errors.lastName.message}</FormErrorMessage>
          <FormHelperText>{t("Please provide your last name")}</FormHelperText>
        </FormControl>
        {me.lastName !== value && (
          <Button
            mt="10px"
            leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
            variant={"solid"}
            colorScheme="teal"
            size={"sm"}
            isLoading={isSaving}
            type="submit"
          >
            {t("Save change")}
          </Button>
        )}
      </form>
    </>
  );
};
